module.exports = __webpack_public_path__ + "img/s1-3.b44fa7e9.jpg";